import { Experiment } from '@amplitude/experiment-js-client';
import * as amplitude from '@amplitude/analytics-browser';

import { env } from '@/constants';
import type { FeatureFlagProviderService } from '@arcual/lib-app-platform';

export class AmplitudeFeatureFlagService implements FeatureFlagProviderService {
  private initialized = true;
  private experiment;

  constructor() {
    this.experiment = Experiment.initializeWithAmplitudeAnalytics(env.VITE_AMPLITUDE_CLIENT_KEY);
  }

  async initialize() {
    try {
      await this.experiment.start();
      this.initialized = true;
    } catch {
      this.initialized = false;
    }
  }

  public setAccount(accountId: string) {
    this.experiment.setUser({ user_id: accountId });
    amplitude.setUserId(accountId);
    amplitude.track('identify_user');
    this.experiment.fetch();
  }

  public isHealthy(): boolean {
    return this.initialized;
  }

  public isFeatureEnabled(key: string): boolean {
    return this.experiment.variant(key)?.value === 'on';
  }
}
